import { gql } from '@apollo/client'

export const CANCEL_USER_SUBSCRIPTION = gql`
    mutation booking_cancel_user_subscription($subscription_id: String!, $reason: String!) {
        booking_cancel_user_subscription(subscription_id: $subscription_id, reason: $reason) {
            success
        }
    }
`
